import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-search',
  templateUrl: './smart-search.component.html',
  styleUrls: ['./smart-search.component.scss']
})
export class SmartSearchComponent implements OnInit {

  searchValue:string;
  searchArea=false;
  showCancel=false;
  showSpinner=false;

  constructor() { }

  ngOnInit(): void {
  }

  onKeydown(event){
     var findData;
    if(event.target.value!='') {
        findData= (event.target.value).trim();
        if(findData.length>=2) {
            this.showCancel=true;
            this.searchArea=true;
            this.showSpinner=true;
            setTimeout(() => {
                this.showSpinner=false;

            }, 500);

        } else {
            this.searchArea=false;
        }
    } else {
        this.searchArea=false;
        this.showCancel=false;
    }

}
close(){
  this.searchArea=false;
  this.showCancel=false;
  this.searchValue='';


}

}
